<template>
    <div v-if="loading" data-qa="confirmation-loading">
        <DsSpinner
            :size="72"
            :thickness="5"
            class="loading-icon"
            data-qa="loading-icon"
        />

        <p class="confirmation-processing-loading-title" data-qa="confirmation-processing-loading-title">
            {{ $t('myaccount.quick.add.confirmation.processing.payment.title') }}
        </p>

        <p class="confirmation-processing-loading-sentence" data-qa="confirmation-processing-loading-sentence">
            {{ confirmationProcessingSentence }}
        </p>

        <p class="confirmation-processing-email-sentence" data-qa="confirmation-processing-email-sentence">
            {{ confirmationEmailSentence }}
        </p>
    </div>
    <div v-else-if="success" data-qa="confirmation-success">
        <p class="confirmation-processing-success-title" data-qa="confirmation-processing-success-title">
            {{ $t('myaccount.quick.add.confirmation.success.title') }}
        </p>

        <p class="confirmation-processing-success-sentence" data-qa="confirmation-processing-success-sentence">
            {{ confirmationSuccessStentence }}
        </p>

        <p class="confirmation-processing-email-sentence" data-qa="confirmation-processing-email-sentence">
            {{ confirmationEmailSentence }}
        </p>
    </div>
    <div v-else-if="error" data-qa="confirmation-error" />
</template>

<script>
const LOADING = 'loading';
const SUCCESS = 'success';
const ERROR = 'error';

export default {

    props: {
        newTotalQuantity: String,
        loadingStatus: String,
        subscriptionDetails: Object,
        contactDetails: Object,
        selectedTier: Number,
        currentTier: Number,
    },

    computed: {
        loading() {
            return this.loadingStatus === LOADING;
        },

        success() {
            return this.loadingStatus === SUCCESS;
        },

        error() {
            return this.loadingStatus === ERROR;
        },

        estimate() {
            return this.subscriptionDetails.estimate;
        },

        plan() {
            return this.estimate?.estimateLineItems?.find(({ type }) => type === 'PLAN') || {};
        },

        contactPricingTiers() {
            return this.contactDetails.contactPricingTiers;
        },

        totalContacts() {
            return this.contactPricingTiers.at(this.selectedTier).maxUnits;
        },

        confirmationSuccessStentence() {
            return this.$t('myaccount.quick.add.confirmation.success.sentence.contacts', {
                planName: this.plan.name,
                totalContacts: this.futureNumberOfContacts,
            });
        },

        confirmationProcessingSentence() {
            return this.$t('myaccount.quick.add.confirmation.processing.payment.sentence.contacts', {
                planName: this.plan.name,
                totalContacts: this.futureNumberOfContacts,
            });
        },

        confirmationEmailSentence() {
            return this.$t('myaccount.quick.add.confirmation.processing.payment.email.sentence');
        },

        addonsByType() {
            const addonsByType = {
                CONTACT: 0,
                USER: 0,
            };

            this.subscriptionDetails?.lineItems.forEach((addon) => {
                if (addon.type === 'CONTACT') {
                    addonsByType.CONTACT += Number(addon.quantity);
                } else if (addon.type === 'USER') {
                    addonsByType.USER += Number(addon.quantity);
                }
            });

            addonsByType.CONTACT += this.newAdditionalContactQuantityNumber;

            return addonsByType;
        },

        newAdditionalContactQuantityNumber() {
            return this.contactDetails?.contactPricingTiers.at(this.selectedTier)?.maxUnits - this.contactDetails?.contactPricingTiers.at(this.currentTier)?.maxUnits;
        },

        futureNumberOfContacts() {
            return this.numberWithCommas(this.addonsByType.CONTACT);
        },
    },

    methods: {
        numberWithCommas(x) {
            if (!x) {
                return 0;
            }
            const parts = x.toString().split('.');

            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            return parts.join('.');
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmation-processing-success-title {
    font-size: $font-size-jumbo;
    font-weight: $font-weight-bold;
    padding-top: $spacing-300;
    line-height: normal;
}

.confirmation-processing-loading-title {
    font-size: $font-size-jumbo;
    font-weight: $font-weight-bold;
    padding-top: $spacing-300;
}

.confirmation-processing-success-sentence {
    padding-top: $spacing-100;
    padding-bottom: $spacing-200;
    font-size: $font-size-md;
}

.confirmation-processing-loading-sentence {
    padding-top: $spacing-100;
    padding-bottom: $spacing-200;
    font-size: $font-size-md;
}

.confirmation-processing-email-sentence {
    font-size: $font-size-md;
    color: $color-text-subtle;
}
</style>
